<script lang="ts">
  import { del } from "@util/api"
  import { createErrorNotice, GENERIC_ERROR_MESSAGE } from "@util/notices"

  export let path
  export let confirmMsg

  let isProcessing = false

  async function deleteItem() {
    isProcessing = true
    if (confirm(confirmMsg)) {
      try {
        let result = await del(path)
        let { meta } = result.body
        if (result.ok && meta) {
          let state = { flash: meta.flash }
          history.pushState(state, null, meta.redirect)
          history.go()
        } else {
          createErrorNotice(GENERIC_ERROR_MESSAGE)
          isProcessing = false
        }
      } catch (error) {
        createErrorNotice(GENERIC_ERROR_MESSAGE)
        isProcessing = false
      }
    } else {
      isProcessing = false
    }
  }
</script>

<button
  class="button delete-button less-important select-none cursor-pointer"
  on:click|preventDefault={deleteItem}
  disabled={isProcessing}>
  <slot />
</button>
